// extracted by mini-css-extract-plugin
export default {"page":"ai-z","cartModal":"bi-z","checkout":"ci-z","placeholder":"di-z","account":"ei-z"};